import InfoItem from "../../components/forms/InfoItem";
import { Button } from "../../components/forms/Form";

export const UserInfo = (props) => {
  return (
    <>
      <div className="settings-user-info-box">
        <h3>Informazioni utente</h3>
        {props.inputs.map((input, i) => (
          <InfoItem
            key={`input_${i}`}
            target={input.target}
            type={input.type}
            placeholder={input.placeholder}
            defaultValue={input.defaultValue}
            // error={input.error}
            label={input.label}
            handleChangeInput={props.handleChangeInput}
          />
        ))}

        <Button
          disabled={props.submitButton.disabled}
          handleSubmit={props.handleSubmit}
          loading={props.submitButton.loading}
          text={props.submitButton.text}
        />
      </div>
    </>
  );
};

export default UserInfo;
